export enum IdVerificationEvents {
  VERIFICATION_UPDATED = 'id_verification_updated',
}